/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'traffic-log-list-expanded-content-communicating-ips';
const prefix = `${moduleName}.${componentName}`;

export const virtualServiceIpLabel = `${prefix}.virtualServiceIpLabel`;
export const sourceClientIpLabel = `${prefix}.sourceClientIpLabel`;
export const serverConnectionIpLabel = `${prefix}.serverConnectionIpLabel`;

export const ENGLISH = {
    [virtualServiceIpLabel]: 'Virtual Service IP',
    [sourceClientIpLabel]: 'Source Client IP',
    [serverConnectionIpLabel]: 'Server Connection IP',
};
